module.exports = __webpack_public_path__ + "img/pie-chart-seven.0eba4877.svg";